/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacLibra = createLucideIcon("zodiac-libra", [
  [
    "path",
    {
      d: "M3 16h6.857c.162-.012.19-.323.038-.38a6 6 0 1 1 4.212 0c-.153.057-.125.368.038.38H21",
      key: "1novf0"
    }
  ],
  ["path", { d: "M3 20h18", key: "1l19wn" }]
]);

export { ZodiacLibra as default };
//# sourceMappingURL=zodiac-libra.js.map
